export const ROUTES = {
  HOME: '/',
  ABOUT: '/about',
  TERMS: '/terms',
  CREDITS: '/credits',
} as const;
